module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "compose-message",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: "compose",
    staticClass: "compose-message"
  }, [_c('div', {
    staticClass: "compose-message__form"
  }, [_c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Compose Message")]), _vm._v(" "), _c('form', {
    staticClass: "form form--inline",
    attrs: {
      "id": "message"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_vm._l((_vm.fields), function(field, key) {
    return _c('module-fieldset', _vm._b({
      key: key,
      attrs: {
        "id": key
      }
    }, 'module-fieldset', field, false))
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "disabled": !_vm.isValid,
      "label": "Send message",
      "loading": _vm.getMessageSending && !_vm.getSentStatus
    }
  })], 2)])])]), _vm._v(" "), (_vm.getSentStatus) ? _c('ui-module-loader', {
    key: "loader",
    attrs: {
      "messages": ['Message sent', 'Please allow up to 2 working days for a response']
    },
    on: {
      "messages-complete": _vm.onMessagesComplete
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74f710a8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ComposeMessage.vue
// module id = 515
// module chunks = 0